import React from 'react';
import './cart-addon.scss';
import Button from '../Button/Button';
import Icon from '../../mweb/Icon/Icon';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { createProductUrl } from '../../../CPMapping';

const CartAddon = props => {
  const { atcCb, desktop, addon } = props;
  if (addon) {
    const { addOnText, productId, sku, imageUrl } = addon;
    const onATC = () => {
      const product = {
        sku,
        productId,
        quantity: 1,
        isCart: true,
      };
      atcCb(product);
    };
    return (
      <div className="cart-addon">
        <div className="cart-addon--image">
          <Link to={createProductUrl(addon.productId)}>
            <Icon src={imageUrl} size={45} />
          </Link>
        </div>
        <div className="cart-addon--copy">{addOnText}</div>
        <div className="cart-addon--atc">
          {desktop && (
            <Button className="button button-ghost" onClick={onATC}>
              Add
            </Button>
          )}
          {!desktop && (
            <Button className="button action-link" onClick={onATC}>
              <div className="justify-content--space-between">
                <span>ADD</span>
                <Icon
                  size={10}
                  class="cart-addon--atc--icon icon-common-plus"
                />
              </div>
            </Button>
          )}
        </div>
      </div>
    );
  }
  return false;
};

CartAddon.propTypes = {
  addon: PropTypes.object.isRequired,
  atcCb: PropTypes.func.isRequired,
  desktop: PropTypes.bool,
};

export default CartAddon;
